import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { provideDefaultConfigFactory, StateConfig, StateTransferType } from '@spartacus/core';
import { reducerProvider, reducerToken } from './reducers';
import { TRACKING_FEATURE } from './tracking-state';

function trackingStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: { [TRACKING_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
    },
  };
}

@NgModule({
  imports: [StoreModule.forFeature(TRACKING_FEATURE, reducerToken)],
  providers: [provideDefaultConfigFactory(trackingStoreConfigFactory), reducerProvider],
})
export class TrackingStoreModule {}
